// import dotenv from 'dotenv'; // Dotenv is for Node.js, not for browser code
// dotenv.config();

const safeProcessEnv = (typeof process !== 'undefined' && process.env) ? process.env : {};

export const envConfig = {
  isLive: safeProcessEnv.IS_LIVE === 'live' ? true : false,
  corporateAppUrl: safeProcessEnv.REACT_APP_CORPORATE_APP || '',
  wayaquickAppUrl: safeProcessEnv.REACT_APP_WAYAQUICK_APP || '',
  wayaposAppUrl: safeProcessEnv.REACT_APP_WAYAQUICK_POS || '',
  wayagramAppUrl: safeProcessEnv.REACT_APP_WAYAGRAM_APP || '',
  personalAppUrl: safeProcessEnv.REACT_APP_PERSONAL_APP || '',
  baseUrl: safeProcessEnv.REACT_APP_BASE_URL || '',
  gramUrl: safeProcessEnv.REACT_APP_GRAM_URL || '',
  posUrl: safeProcessEnv.REACT_APP_POS_URL || '',
  wayapayUrl: safeProcessEnv.REACT_APP_WAYAPAY_URL || '',
};
